function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { filter } from 'lodash';
const filterServiceTypeOptions = function () {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (!search) {
    return options;
  }
  const lowerSearch = search.toLowerCase();
  const filtered = options.reduce(function (acc) {
    let curr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const currentValue = curr.label || curr.name;
    if (currentValue.toLowerCase().includes(lowerSearch)) {
      return [...acc, curr];
    }
    const children = filter(curr.children, function () {
      let child = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const currentchildValue = child.label || child.name;
      return currentchildValue.toLowerCase().includes(lowerSearch);
    });
    if (children.length > 0) {
      return [...acc, _objectSpread(_objectSpread({}, curr), {}, {
        children
      })];
    }
    return acc;
  }, []);
  return filtered;
};
export default filterServiceTypeOptions;
//# sourceMappingURL=filterServiceTypeOptions.js.map